export const WALL_BRIGHTNESS_NORMAL = 1.0;
export const WALL_BRIGHTNESS_DARK = 0.82;

/**
 * @param {'normal' | 'dark'} [shadeVariant]
 * @returns {number}
 */
export function getWallBrightnessMultiplier(shadeVariant = 'normal') {
  return shadeVariant === 'dark' ? WALL_BRIGHTNESS_DARK : WALL_BRIGHTNESS_NORMAL;
}

/**
 * @param {number} channel
 * @param {number} multiplier
 */
function multiplyChannel(channel, multiplier) {
  return Math.max(0, Math.min(255, Math.round(channel * multiplier)));
}

/**
 * @param {string} hex
 * @param {number} multiplier
 * @returns {string}
 */
export function applyBrightnessToHex(hex, multiplier) {
  const match = /^#?([0-9A-Fa-f]{6})$/.exec(String(hex || '').trim());
  if (!match) return '#ffffff';
  const raw = match[1];
  const r = multiplyChannel(Number.parseInt(raw.slice(0, 2), 16), multiplier);
  const g = multiplyChannel(Number.parseInt(raw.slice(2, 4), 16), multiplier);
  const b = multiplyChannel(Number.parseInt(raw.slice(4, 6), 16), multiplier);
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase();
}

/**
 * @param {import('three').Color} color
 * @param {number} multiplier
 */
export function applyBrightnessToThreeColor(color, multiplier) {
  color.r = Math.min(1, Math.max(0, color.r * multiplier));
  color.g = Math.min(1, Math.max(0, color.g * multiplier));
  color.b = Math.min(1, Math.max(0, color.b * multiplier));
}
